module.exports = __webpack_public_path__ + "static/media/pocket-mobile.9c86be48.png";